<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <Input
          v-model="parameter.name"
          @input="  parameter.pageNow = 1;
            getData()"
          search
          placeholder="标题"
          style="width: auto;margin-left: 20px;"
        />
      </div>
      <div class="search_list">
        <div class="text">状态:</div>
        <Select
          v-model="parameter.state"
          @on-change="
            parameter.pageNow = 1;
            getData();
          "
          class="select"
        >
          <Option :value="0">下架</Option>
          <Option :value="1">正常</Option>
        </Select>
      </div>
      <div class="search_list">
        <Button
          @click="
            upData = {};
            title = '添加';
            Show = true;
          "
          style="margin-left: 15px"
          type="primary"
        >添加</Button>
      </div>
    </div>
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="img">
        <img style="width: 100px" :src="row.img" alt srcset />
      </template>
      <template slot-scope="{ row, index }" slot="state">
        <div v-if="row.state == 0">下架</div>
        <div v-if="row.state == 1">正常</div>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '编辑';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >编辑</Button>

        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >删除</Button>
      </template>
    </Table>

    <Modal width="800" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '删除'">删除</div>

      <div v-else>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>标题:</div>
          <div>
            <Input v-model="upData.name" placeholder="标题" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>提示:</div>
          <div>
            <Input v-model="upData.tips" placeholder="提示" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>跳转链接:</div>
          <div>
            <Input v-model="upData.detailUrl" placeholder="跳转链接" style="width: 300px" />
          </div>
        </div>

        <div style="display: flex; align-items: center">
          <div>图片:</div>
          <Upload
            :on-success="handleSuccess"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            action="api/v1/product/uploads"
          >
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
          </Upload>
          <img style="width: 100px" :src="upData.img" alt />
        </div>

        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态:</div>
          <div>
            <Select v-model="upData.state">
              <Option :value="0">下架</Option>
              <Option :value="1">正常</Option>
            </Select>
          </div>
        </div>
        <!-- <div style="display: flex; align-items: center; margin-top: 15px">
          <div>达标状态:</div>
          <div>
            <Select v-model="upData.complianceStatus">
              <Option :value="2">初审</Option>
              <Option :value="6">终审</Option>
              <Option :value="3">激活</Option>
              <Option :value="4">首刷</Option>
            </Select>
          </div>
        </div>-->
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      userList: { list: [] },
      title: "",
      upData: {},
      Show: false,
      parameter: {
        pageNow: 1
      },
      pageNow1: 1,
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id",
          width: 50
        },
        {
          title: "标题",
          className: "fontcolor",
          align: "center",
          key: "name"
        },
        {
          title: "提示",
          className: "fontcolor",
          align: "center",
          key: "tips"
        },
        {
          title: "跳转链接",
          className: "fontcolor",
          align: "center",
          key: "detailUrl"
        },
        {
          title: "图片",
          align: "center",
          className: "fontcolor",
          slot: "img"
        },

        {
          title: "状态",
          align: "center",
          slot: "state",
          className: "fontcolor",
           width: 100
        },
        // {
        //   title: "达标状态",
        //   align: "center",
        //   slot: "complianceStatus",
        //   className: "fontcolor"
        // },

        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          className: "fontcolor",
          align: "center",
          key: "modifyTime"
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    handleSuccess(res, file) {
      this.upData.img = res.data[0].path;
      this.$forceUpdate();
    },

    UaorderShip() {
      if (this.title == "添加") {
        api.ProductGiftAdd(this.upData).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "编辑") {
        api.ProductGiftEdit(this.upData).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.ProductGiftDel(this.upData.id).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.ProductGiftQueryList(this.parameter).then(res => {
        this.userList = res.body.data;
      });
    }
  }
};
</script>

<style scoped>
</style>